var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAuxiliaryBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 393,
    height: 176,
    viewBox: "0 0 393 176",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4446_2633)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 393,
    height: 176,
    rx: 20,
    fill: "url(#paint0_linear_4446_2633)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_4446_2633)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 302.089,
    cy: 78.0894,
    rx: 117.012,
    ry: 105.421,
    transform: "rotate(-16.7881 302.089 78.0894)",
    fill: "#A8ADB9",
    fillOpacity: 0.41
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_4446_2633)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 302.003,
    cy: 76.2843,
    rx: 111.763,
    ry: 99.734,
    transform: "rotate(-16.7881 302.003 76.2843)",
    fill: "#0096D1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M292.846 112.744C306.753 112.744 318.028 101.469 318.028 87.5618C318.028 73.6542 306.753 62.3799 292.846 62.3799C278.938 62.3799 267.664 73.6542 267.664 87.5618C267.664 101.469 278.938 112.744 292.846 112.744Z",
    fill: "#E5EFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.38 58V60.1897",
    stroke: "#4C241D",
    strokeWidth: 2.18973,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.38 64.5693V66.7591",
    stroke: "#4C241D",
    strokeWidth: 2.18973,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260 62.3799H262.19",
    stroke: "#4C241D",
    strokeWidth: 2.18973,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.569 62.3799H268.759",
    stroke: "#4C241D",
    strokeWidth: 2.18973,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.532 66.7585C308.044 66.7585 309.269 65.533 309.269 64.0213C309.269 62.5096 308.044 61.2842 306.532 61.2842C305.02 61.2842 303.795 62.5096 303.795 64.0213C303.795 65.533 305.02 66.7585 306.532 66.7585Z",
    stroke: "#4C241D",
    strokeWidth: 2.18973,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.325 67.9634C279.325 68.1949 279.257 68.4212 279.128 68.6136C278.999 68.8061 278.817 68.9561 278.603 69.0447C278.389 69.1333 278.153 69.1565 277.926 69.1113C277.699 69.0661 277.491 68.9547 277.327 68.791C277.163 68.6273 277.052 68.4188 277.007 68.1917C276.962 67.9647 276.985 67.7293 277.073 67.5155C277.162 67.3016 277.312 67.1188 277.505 66.9902C277.697 66.8616 277.923 66.793 278.155 66.793C278.465 66.793 278.763 66.9163 278.982 67.1358C279.202 67.3553 279.325 67.653 279.325 67.9634Z",
    fill: "#4C241D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.12 70.1528C323.12 70.3843 323.051 70.6106 322.923 70.8031C322.794 70.9955 322.611 71.1456 322.398 71.2341C322.184 71.3227 321.948 71.3459 321.721 71.3008C321.494 71.2556 321.286 71.1441 321.122 70.9804C320.958 70.8168 320.847 70.6082 320.802 70.3812C320.757 70.1541 320.78 69.9188 320.868 69.7049C320.957 69.4911 321.107 69.3083 321.299 69.1797C321.492 69.0511 321.718 68.9824 321.95 68.9824C322.26 68.9824 322.558 69.1057 322.777 69.3252C322.997 69.5447 323.12 69.8424 323.12 70.1528Z",
    fill: "#4C241D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.227 115.7C281.097 114.571 280.463 113.039 280.463 111.442C280.463 109.845 281.097 108.313 282.227 107.184L306.998 82.416C308.127 81.2867 309.659 80.6523 311.256 80.6523C312.853 80.6523 314.384 81.2867 315.514 82.416C316.643 83.5453 317.277 85.0769 317.277 86.6739C317.277 88.2709 316.643 89.8025 315.514 90.9318L290.739 115.7C289.61 116.828 288.079 117.462 286.483 117.462C284.887 117.462 283.356 116.828 282.227 115.7Z",
    fill: "#BF7E68",
    stroke: "#4C241D",
    strokeWidth: 2.18973,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.044 105.079V117.123",
    stroke: "#4C241D",
    strokeWidth: 2.18973,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.665 118.218H276.424",
    stroke: "#4C241D",
    strokeWidth: 2.18973,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.483 90.6619C259.116 97.5245 263.765 105.032 271.009 105.504C271.271 105.521 271.535 105.53 271.803 105.53C273.351 105.534 274.886 105.237 276.321 104.654C278.797 103.585 280.799 101.651 281.951 99.2119C283.104 96.7732 283.327 93.9981 282.58 91.4064L280.083 82.0869H264.351L261.483 90.6619Z",
    fill: "white",
    stroke: "#4C241D",
    strokeWidth: 2.18973,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.943 95.6703C261.204 98.2289 262.354 100.615 264.194 102.412C266.033 104.209 268.446 105.304 271.01 105.504C271.272 105.522 271.536 105.531 271.803 105.531C273.352 105.535 274.887 105.237 276.322 104.655C278.798 103.586 280.8 101.651 281.952 99.2124C283.104 96.7737 283.328 93.9986 282.581 91.4069L282.398 90.75C279.248 91.6777 276.24 93.033 273.459 94.778C267.884 98.0155 263.62 97.1002 260.943 95.6703Z",
    fill: "#F53E28",
    stroke: "#4C241D",
    strokeWidth: 2.18973,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.106 86.3037L310.364 86.4668",
    stroke: "#4C241D",
    strokeWidth: 2.18973,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.442 93.9678L302.7 94.1309",
    stroke: "#4C241D",
    strokeWidth: 2.18973,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.778 101.632L293.941 101.713",
    stroke: "#4C241D",
    strokeWidth: 2.18973,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.902 108.217L288.467 108.365",
    stroke: "#4C241D",
    strokeWidth: 2.18973,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.131 105.079H319.123V117.123H296.131V105.079Z",
    fill: "#D9BE6F",
    stroke: "#4C241D",
    strokeWidth: 2.18973,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.7 98.5098L296.131 105.079H305.985V111.101C305.985 111.536 306.158 111.954 306.466 112.262C306.774 112.57 307.191 112.743 307.627 112.743C308.062 112.743 308.48 112.57 308.788 112.262C309.096 111.954 309.269 111.536 309.269 111.101V107.816C309.269 108.252 309.442 108.669 309.75 108.977C310.058 109.285 310.476 109.458 310.912 109.458C311.347 109.458 311.765 109.285 312.073 108.977C312.381 108.669 312.554 108.252 312.554 107.816V105.079H319.123L302.7 98.5098Z",
    fill: "#FFCE56",
    stroke: "#4C241D",
    strokeWidth: 2.18973,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 294.5,
    cy: 123,
    rx: 32.5,
    ry: 4,
    fill: "url(#paint1_radial_4446_2633)",
    fillOpacity: 0.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_4446_2633",
    x: 185.97,
    y: -32.126,
    width: 232.237,
    height: 216.68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3.75104
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.6888
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4446_2633"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_4446_2633",
    x: 189.29,
    y: -24.5352,
    width: 225.426,
    height: 205.391,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.87552
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.937759
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.3 0 0 0 0 0.3 0 0 0 0 0.3 0 0 0 0.67 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4446_2633"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4446_2633",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4446_2633",
    x1: 6.99999,
    y1: 0.00000817195,
    x2: 232,
    y2: 170,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#012063"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0096D1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_4446_2633",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(294.5 123) rotate(90) scale(4 32.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4446_2633"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 393,
    height: 176,
    rx: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuxiliaryBg);
export default __webpack_public_path__ + "static/media/auxiliary-bg.ead1938e00a2730cda7a99f64378c491.svg";
export { ForwardRef as ReactComponent };